class PageTeaserCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.headline = options?.headline ? 'n/a'
        @.link = options?.link ? '#'
        @.linkText = options?.linkText ? 'Zur Seite'
        @.tag = options?.tag ? 'li'
        @.text = options?.text ? 'n/a'

        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'page-teaser'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.innerHTML = "
            <div class='page-teaser__content'>
                <h3 class='headline headline--4 page-teaser__headline'>#{ @.headline }</h3>
                <div class='page-teaser__text'>#{ @.text }</div>
            </div>
            <div class='page-teaser__link'>
            </div>
        "
        @.$el.querySelector '.page-teaser__link'
            .appendChild new ButtonCreate {
                attrs: {
                    class: ['page-teaser__button']
                },
                link: @.link,
                text: @.linkText
            }
        return

window.CreatePageTeaser = (options) ->
    return new PageTeaserCreate options